import { DefaultService } from '@/services/DefaultService';

export default class LimiteCreditoClienteService extends DefaultService {
    constructor(http, router, env) {
		super(http, router, env);
	}

    findAllVendas(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/ven/cliente/limitecredito.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    findAllAgro(column, order, page, limit, situacao, idcliente, ...params) {
        return this._http.get( encodeURI(`${this._env}/agro/cliente/limitecredito.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idcliente=${idcliente}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    find(id) {
		return this._http.get(`${this._env}/ven/cliente/limitecredito/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
	}

    updateSituacaoVendas(saldocliente) {
        return this._http.post(`${this._env}/ven/cliente/limitecredito/updatesituacao`, saldocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacaoAgro(saldocliente) {
        return this._http.post(`${this._env}/agro/cliente/limitecredito/updatesituacao`, saldocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveVendas(saldocliente) {
        return this._http.post(`${this._env}/ven/cliente/limitecredito`, saldocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });   
    }

    saveAgro(saldocliente) {
        return this._http.post(`${this._env}/agro/cliente/limitecredito`, saldocliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });   
    }

    findAllNaoAssociadosVendas(idcliente, ...params) {
		return this._http.get( encodeURI(`${this._env}/vendas/cliente/limitecredito/naoassociados?idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}

    findAllNaoAssociadosAgro(idcliente, ...params) {
		return this._http.get( encodeURI(`${this._env}/agro/cliente/limitecredito/naoassociados?idcliente=${idcliente}&param=${params}`), this._headers ).then(res => {
			return res.body;
		}, err => {
			this.verifyError(err);
			throw err;
		});
	}
}